import Sectors from "../Sectors/Sectors";
import styles from "./Step1.module.scss";
import { Tooltip } from "react-tooltip";
import { VscChromeClose, VscLockSmall } from "react-icons/vsc";
import { motion, AnimatePresence } from "framer-motion";
import Utilities from "../utils/Utilities.js";
import { useEffect, useState } from "react";
import usePreferencesStore from "../../store/preferencesStore.js";

function Step1(props) {
  const [open, setOpen] = useState(props.selectedServices.length > 0);
  const [isAnimating, setIsAnimating] = useState(false);
  const { preferences } = usePreferencesStore();

  // Gestione immediata dell'apertura quando ci sono servizi selezionati
  useEffect(() => {
    if (props.selectedServices.length > 0) {
      setOpen(true);
      setIsAnimating(true);
    } else {
      setIsAnimating(false);
      setTimeout(() => setOpen(false), 200); // Ridotto il tempo di chiusura
    }
  }, [props.selectedServices.length]);

  // Ordina i servizi selezionati
  const sortedItems = props.selectedServices?.sort(
    (a, b) => a.sortOrder - b.sortOrder
  );

  const handleDeSelectService = (onServiceDeSelect, item) => {
    if (onServiceDeSelect) {
      onServiceDeSelect(item);
    }
  };

  return (
    <div className={styles.container}>
      <Sectors
        data={props.data}
        selectedServices={props.selectedServices}
        onServiceSelect={props.onServiceSelect}
        onServiceDeSelect={props.onServiceDeSelect}
        onSearch={props.onSearch}
        currentStep={props.currentStep}
      />

      {!props.isMobile && open && (
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.2 }}
            className={styles["cart-container-wrapper"]}
          >
            <div className={styles["cart-container"]}>
              <div className={styles["cart-inner-container"]}>
                <div className={styles["cart-services-container"]}>
                  {sortedItems?.map((item, index) => (
                    <div key={index}>
                      {item.selectionMode === Utilities.MANUAL ? (
                        <div className={styles["cart-item"]}>
                          <span className={styles["cart-item-name"]}>
                            {item.name[0].toUpperCase() +
                              item.name.slice(1).toLowerCase()}
                          </span>
                          <VscChromeClose
                            size="12"
                            className={styles["cart-item-close-icon"]}
                            onClick={() =>
                              handleDeSelectService(
                                props.onServiceDeSelect,
                                item
                              )
                            }
                          />
                        </div>
                      ) : (
                        <div
                          className={styles["cart-item-included"]}
                          data-tooltip-id="info-icon-tooltip"
                          data-tooltip-content="Servizio incluso nel pacchetto"
                          data-tooltip-place="top-end"
                        >
                          <span className={styles["cart-item-name"]}>
                            {item.name[0].toUpperCase() +
                              item.name.slice(1).toLowerCase()}
                          </span>
                          <VscLockSmall
                            size="15"
                            className={styles["cart-item-lock-icon"]}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <button
                  className={styles["cart-book-button"]}
                  onClick={props.onBook}
                  disabled={props.stepBetween1and2Loading}
                >
                  {props.stepBetween1and2Loading
                    ? "Loading..."
                    : `PRENOTA ${props.selectedServices.length} SERVIZI`}
                </button>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      )}

      <Tooltip
        id="info-icon-tooltip"
        className={styles.infoTooltip}
        place="top-end"
        type="light"
      />
    </div>
  );
}

export default Step1;
